import React, { useRef, useState } from "react";
import { KTSVG } from "../../../../_metronic/helpers";
import { ExperienceSummary } from "../../teamExperiences/models/ExperienceSummaryModel";
import { useHistory } from "react-router-dom";
import { formatDateShortIntl2 } from "../../../helpers/FormatDate";
import { defaultExperienceImage, defaultProfileImage } from "../../../utils/constants";
import { formatUsdAmount } from "../../../utils/dateValidations";

interface Props {
  items: ExperienceSummary[];
  eventsScroll:boolean;
}

export const ExperiencePreviewInviteCarousel: React.FC<Props> = ({ items, eventsScroll }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // Drag tracking
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const history = useHistory()

  // === Drag-to-scroll ===
  const handleMouseDown = (e: React.MouseEvent) => {
    if(!eventsScroll) return;
    setIsDown(true);
    setStartX(e.pageX - (scrollRef.current?.offsetLeft || 0));
    setScrollLeft(scrollRef.current?.scrollLeft || 0);
  };

  const handleMouseLeave = () => setIsDown(false);
  const handleMouseUp = () => setIsDown(false);

  const handleMouseMove = (e: React.MouseEvent) => {
    if(!eventsScroll) return;
    if (!isDown || !scrollRef.current) return;
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1; // scroll speed
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // === Flechas ===
  const scrollNext = () => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: 360, behavior: "smooth" });
  };

  const scrollPrev = () => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: -360, behavior: "smooth" });
  };

  return (
    <div className={`experience-preview-invite-carousel ${items?.length > 0 ? '' : 'd-none'}`}>
      {/* FLECHAS */}
      <button className="carousel-btn left" onClick={scrollPrev}>‹</button>
      <button className="carousel-btn right" onClick={scrollNext}>›</button>

      {/* WRAPPER */}
      <div
        ref={scrollRef}
        className="experience-preview-invite-scroll"
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}>
        {(items ?? []).map((item,index) => (
          <div onClick={()=>history.replace(`/experience/detail/${item.id}`)} className="experience-preview-invite-card" key={index} >
            <div className="experience-preview-invite-card-img">
              <img src={item.coverImage ?? defaultExperienceImage} onError={(e) => {e.currentTarget.src = defaultExperienceImage}} alt={item.title} />
            </div>

            <div className="experience-preview-invite-card-info">
              <div className="experience-preview-invite-badges">
                <div className="experience-preview-invite-badge">
                  <div className='line-svg'>
                    <KTSVG path='/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg' />
                  </div>
                  New
                  <div className='line-svg'>
                    <KTSVG path='/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg' />
                  </div>
                </div>
                <div className="experience-preview-invite-badge-secondary">
                  Invited by
                </div>
              </div>

              <div className="experience-preview-invite-users">
                <div className="experience-preview-invite-user">
                  <img src={item.submittedBy.image} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} />
                  <span>{item.submittedBy.name}</span>
                </div>
                {/* {item.invited.map((u, i) => (
                  <div className="experience-preview-invite-user" key={i}>
                    <img src={u.img} />
                    <span>{u.name}</span>
                  </div>
                ))} */}
              </div>

              <div className="experience-preview-invite-title">{item.title}</div>
              <div className="experience-preview-invite-hover w-100">
                <div className="experience-preview-invite-categories mb-4">
                    <span>lifestyle</span>
                </div>
                <div className="experience-preview-invite-description">
                    Make a painting together with Kristina at her studio - be an artist. Invited people who want to learn to paiint or make a painting together for the interior.asdasdad
                </div>
                <div className="experience-preview-details tap-flex-center">
                    <div className="experience-preview-detail">
                        <span className="experience-preview-icon-18">
                            <KTSVG path='/media/svg/nobilis/location-white.svg' />
                        </span>
                        <span className='labels'>{item?.city || 'Location TBA'}</span>
                    </div>
                    <div className="experience-preview-detail">
                        <span className="experience-preview-icon-18">
                            <KTSVG path='/media/svg/nobilis/calendar-white.svg' />
                        </span>
                        <div className='labels'>
                            {(item.dates ?? []).map((item,index)=>(
                                <span key={`date-${index}`}>
                                    { formatDateShortIntl2(item.end) == formatDateShortIntl2(item.start) ?
                                        formatDateShortIntl2(item.start) :
                                        `${formatDateShortIntl2(item.start)} / ${formatDateShortIntl2(item.end)}`
                                    }
                                </span>
                            ))}
                        </div>
                        <div className={`labels ${item.dates?.length > 0 ? 'd-none' : ''}`}>
                            { 'Date TBA' }
                        </div>
                    </div>
                    <div className="experience-preview-detail">
                        <span className="experience-preview-icon-18">
                            <KTSVG path='/media/svg/nobilis/currency-white.svg' />
                        </span>
                        <span className='labels'>{formatUsdAmount(item.pricePerGuest) || 'Pending'}&nbsp;/&nbsp;{item?.priceType === 2 || (item as any)?.price_type === 2 ? 'Group' : 'Guest'}</span>
                    </div>
                </div>
            </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
